import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './app';
import reportWebVitals from './reportWebVitals';
import {makeMockServer} from './mocks/server';
import env from './utils/env';
import { Envs } from './features/common/models/generic-enum';
import { initLDProvider } from './features/launchdarkly/ld-provider';

// will load mock api for the following envs.
// @ts-ignore
if ((env.appEnv === Envs.Local || env.appEnv===Envs.Demo) && !window.Cypress) {
  console.log(`${env.appEnv} init mock`);
  makeMockServer(env.appEnv);
}

const root = document.getElementById('root') as HTMLElement;
const reactRoot = createRoot(root);

// Initialize LaunchDarkly provider asynchronously
async function initApp() {
  try {
    const LDProvider = await initLDProvider();

    reactRoot.render(
      <React.StrictMode>
        {LDProvider ? (
          <LDProvider>
            <App />
          </LDProvider>
        ) : (
          <App />
        )}
      </React.StrictMode>
    );
  } catch (error) {
    console.warn('Failed to initialize LaunchDarkly:', error);
    // Fallback: render app without LaunchDarkly
    reactRoot.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
  }
}

// Start the app
initApp();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
